import { Typography } from "@material-ui/core";
import { useRef, useState } from "react";
import Parser from "html-react-parser";
import * as theme from "../theme";
import { OrangeButton } from "../general/OrangeButton";
import { termsText } from "../helper/constants";
import { useNavigate } from "react-router-dom";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";
import translations from "../utils/translations";

const TermsConditions = (props) => {
  const [termsFinish, setTermsFinish] = useState(true);
  const listInnerRef = useRef();
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  let history = useNavigate();
  const token = window.location.search.split("?id=")[1];
  function checkScroll() {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const scrolledProgress = Math.ceil(scrollTop + clientHeight + 30);
      if (scrolledProgress >= scrollHeight && termsFinish) {
        setTermsFinish(false);
      }
    }
  }
  function handleClick() {
    //history(`/signup?id=${token}`);
    document.location.href = `/login` 
  }
  return (
    <div
      style={{
        height: "100%",
        paddingLeft: "1rem",
        backgroundColor: theme.COLORS.question_area_bg,
      }}
    >
      <Typography
        variant="h5"
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "5vmin",
          color: theme.COLORS.primary_navyblue,
          marginTop: "2rem",
        }}
      >
        {translations[languagepreference].welcome}
   
      </Typography>
      <Typography
        style={{
          fontSize: 15,
          fontFamily: "GibsonRegular",
        }}
      >
        {translations[languagepreference].signupInstruction}
     
      </Typography>
      <Typography
        variant="h5"
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "5vmin",
          color: theme.COLORS.secondary_skyblue,
          marginTop: "2rem",
        }}
      >
        {translations[languagepreference].termsHeading}
      
      </Typography>
      <div
        onScroll={checkScroll}
        ref={listInnerRef}
        style={{
          overflow: "scroll",
          border: "1px solid black",
          backgroundColor: "#fffcf4",
          height: "60%",
          margin: "1rem 0",
          padding: "1rem 1rem 0",
          textAlign: "justify",
        }}
      >
        {Parser(termsText[languagepreference])}
      </div>
      <OrangeButton
        disable={termsFinish}
        width="50%"
        style={{ fontWeight: "700" }}
        fontSize="2.5vmin"
        text={translations[languagepreference].agreeButton}
        onClick={handleClick}
      ></OrangeButton>
    </div>
  );
};
export default TermsConditions;
